<template>
  <div class="headerReports">
    <h1>Reportes</h1>
    <v-container>
      <v-row no-gutters>
        <v-col md="4" sm="6" class="pa-2" v-for="(item, i) in reports" :key="i">
          <v-card class="cardStyle">
            <v-card-title>{{ item.reportName }}</v-card-title>
            <div class="icon-item" >
              <img :src="item.icon"/>
            </div>
            <div class="d-flex justify-end pa-2">
              <detailReport :reportProps="item"/>
            </div>
          </v-card>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>
import {
  ACTION_GET_LIST_REPORTS,
  GET_LIST_REPORTS,
  REPORTS_M,
} from "@/views/reports/store/types/types.js";
import { mapActions, mapGetters } from "vuex";
import detailReport from "@/views/reports/pages/detail_report/detail_report_page.vue";

export default {
  name: "listReportsComponent",
  components: {
    detailReport,
  },
  async mounted() {
    await this.getReports();
  },

  methods: {
    ...mapActions({
      getReports: `${REPORTS_M}${ACTION_GET_LIST_REPORTS}`,
    }),
  },
  computed: {
    ...mapGetters({
      reports: `${REPORTS_M}${GET_LIST_REPORTS}`,
    }),
  },
};
</script>

<style lang="css" scoped>
body {
  font-family: "Nunito Sans", sans-serif;
}

h1,
h2,
h3,
h4,
h5,
h6 {
  font-family: "Amsi Pro", sans-serif;
  color: #2d0049;
  font-weight: normal;
}

.icon-item {
  width: 100%;
  height: 100px;
  display: flex;
  justify-content: flex-end;
  align-items: center;
}

.icon-item img {
  width: 60%;
  height: 100%;
  object-fit: contain;
  padding-right: 10px;
}

.cardStyle {
  border: 3px solid;
  border-color: #f2b37b;
  border-radius: 15px;
}

.headerReports {
  display: flex;
  gap: 40px;
  flex-direction: column;
  margin-top: 20px;
  margin-left: 20px;
}

@media screen and (max-width: 414px) {
  h1 {
    font-size: 3vh;
    margin-left: 2vh;
  }

  .cardStyle{
    min-width: max-content;
  }

}

@media screen and (min-width: 414px) {
  h1 {
    font-size: 4vh;
    margin-left: 2vh;
  }

  .cardStyle{
    min-width: max-content;
  }
}

@media screen and (max-width: 280px) {
  h1 {
    font-size: 3vh;
    margin-left: 2vh;
  }

  h2 {
    font-size: 2vh;
  }

  .cardStyle{
    min-width: max-content;
  }
}
</style>
